// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"5d9f2266","232":"fd0de67f","453":"abff59fe","941":"c73b0786"}[chunkId] + ".chunk.js";
};